import React, { useEffect,useState } from 'react';
import { Card, Table, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SubscriptionEditModel from '../components/Modals/SubscriptionEditModel'
import * as type from '../store/types';
import Title from "antd/es/typography/Title";
import { render } from '@testing-library/react';

const MySubscriptionTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null) // State to store the selected row's _id
  
  const showModal = (_id) => {
    setSelectedId(_id)
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedId(null)
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setSelectedId(null)
  };

  const dispatch = useDispatch();

  // Fetch the subscription data from the Redux store
  const { subscriptions = [], loading, error } = useSelector(state => state.viewSubscription || {});

  // Dispatch the action to fetch subscription plans when the component mounts
  useEffect(() => {
    dispatch({ type: type.SUBSCRIPTIONS_FETCH_REQUEST });
  }, [dispatch]);

  // Handle loading state
  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center',
        alignItems: 'center', height: '100vh', textAlign: 'center',}}>
        <div className="loader"></div> 
        <p>Loading... Please hold on team blaccdot!</p>
      </div>
    );
  }
  

  // Handle error state
  if (error) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <h5 style={{ color: 'black' }}>Blaccdot's team An error has occurred on the server. Please try again later</h5>
        <p style={{ color: 'red' }}>Error response : {error}</p>
      </div>
    );
  }

  // Define the columns for the Ant Design Table
  const columns = [
    {
      title: 'Plan Name (Title)',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Plan Amount',
      dataIndex: 'monthAmount',
      key: 'monthAmount',
    },
    {
      title: 'Domain',
      dataIndex: 'category',
      key: 'category',
      render: (category) => category?.name || '-'
    },
    {
      title: 'Tax Amount',
      dataIndex: 'taxAmount',
      key: 'taxAmount',
    },
    {
      title: 'Credits',
      dataIndex: 'creditpoints',
      key: 'creditpoints',
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (_, record) => (
        <a onClick={()=> showModal(record._id)} style={{ color: 'red' }}>Edit</a>
      ),
    },
  ];

  return (
    <div>
      <Title level={2}>Subscription master table</Title>
      <Card
        extra={
          <Link to="/admin/subscription-master-form">
            <button className="button-15">Add Subscription</button>
          </Link>
        } style={{ width: '100%' }} >
        <Table
          columns={columns}
          expandable={{
            expandedRowRender: (record) => (
              <>
                <h6 className="mb-2">PLAN LIST</h6>
                <ul className="ml-0">
                  {record.textcontent?.plan1 && <li>{record.textcontent.plan1}</li>}
                  {record.textcontent?.plan2 && <li>{record.textcontent.plan2}</li>}
                  {record.textcontent?.plan3 && <li>{record.textcontent.plan3}</li>}
                  {record.textcontent?.plan4 && <li>{record.textcontent.plan4}</li>}
                  {record.textcontent?.plan5 && <li>{record.textcontent.plan5}</li>}
                  {record.textcontent?.plan6 && <li>{record.textcontent.plan6}</li>}
                  {record.textcontent?.plan7 && <li>{record.textcontent.plan7}</li>}
                  {record.textcontent?.plan8 && <li>{record.textcontent.plan8}</li>}
                  {record.textcontent?.plan9 && <li>{record.textcontent.plan9}</li>}
                  {record.textcontent?.plan10 && <li>{record.textcontent.plan10}</li>}
                  {record.textcontent?.plan11 && <li>{record.textcontent.plan11}</li>}
                  {record.textcontent?.plan12 && <li>{record.textcontent.plan12}</li>}
                  {record.textcontent?.plan13 && <li>{record.textcontent.plan13}</li>}
                </ul>
              </>
            ),
          }}
          dataSource={subscriptions} // Data comes from the Redux state
          rowKey="_id" // Unique key for each row
        />
      </Card>
      <SubscriptionEditModel subscriptionId={selectedId} isModalOpen={isModalOpen} onCancel={handleCancel} onOk={handleOk} />
    </div>
  );
};

export default MySubscriptionTable;






// import React from 'react'
// import {Card,Table} from 'antd';
// import { Link } from 'react-router-dom';

// const MySubscriptiontable = () => {

//     const columns = [
//         {
//           title: 'Plan Name (Title)',
//           dataIndex: 'planName',
//           key: 'planName',
//         },
//         {
//           title: 'Plan Amount Monthly',
//           dataIndex: 'planmAmount',
//           key: 'planmAmount',
//         },
//         {
//           title: 'Plan Amount Yearly',
//           dataIndex: 'planyAmount',
//           key: 'planyAmount',
//         },
//         {
//           title: 'Monthly Tax',
//           dataIndex: 'monthlyTx',
//           key: 'monthlyTx',
//         },
//         {
//           title: 'Yearly Tax',
//           dataIndex: 'yearlyTx',
//           key: 'yearlyTx',
//         },
//         {
//           title: 'Credits',
//           dataIndex: 'totalCredits',
//           key: 'totalCredits',
//         },
//         {
//           title: 'Action',
//           dataIndex: '',
//           key: 'x',
//           render: () => <a style={{color:'red'}}>Edit</a>,
//         },
//       ];
//       const data = [
//         {
//           key: 1,
//           planName: 'John Brown',
//           planmAmount: 12300,
//           planyAmount: 34000,
//           monthlyTx:230,
//           yearlyTx:230,
//           totalCredits: 23000,
//         },
//         {
//           key: 3,
//           planName: 'Not Expandable',
//           planmAmount: 29,
//           planyAmount: 6263,
//           monthlyTx:230,
//           yearlyTx:230,
//           totalCredits: 3000,
//         },
//       ];

//   return (
//     <div>
//     <h2>Subscription master table</h2>
//        <Card extra={<Link to="/admin/subscription-master-form">
//          <button className="button-15" >Add Subscription</button> </Link>} style={{width: '100%'}}>

//          <Table columns={columns} expandable={{
//             expandedRowRender: (record) => (
//               <>
//                {/* <p style={{margin: 0,}}>Total credits : {record.totalCredits}</p> */}
//                 <h6 className='mb-0'>PLAN LIST</h6>
//                 <ul className='ml-0'>
//                   <li>Get free quotes within minutes</li>
//                   <li>Get Email Support 24/7</li>
//                   <li>3005,00 cerits</li>
//                 </ul>
//               </>
//             ),
//             }}
//             dataSource={data} />

//        </Card>
//     </div>
//   )
// }

// export default MySubscriptiontable